import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetVolumePoolsQueryVariables = Types.Exact<{
  includeRetired?: Types.Scalars['Boolean']['input'];
}>;


export type GetVolumePoolsQuery = { __typename?: 'Query', volumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }> };

export type VolumePoolFragment = { __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null };

export const VolumePoolFragmentDoc = new TypedDocumentString(`
    fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
    `, {"fragmentName":"VolumePool"});
export const GetVolumePoolsDocument = new TypedDocumentString(`
    query GetVolumePools($includeRetired: Boolean! = false) {
  volumePools(includeRetired: $includeRetired) {
    ...VolumePool
  }
}
    fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetVolumePools: build.query<GetVolumePoolsQuery, GetVolumePoolsQueryVariables | void>({
      query: (variables) => ({ document: GetVolumePoolsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetVolumePoolsQuery, useLazyGetVolumePoolsQuery } = injectedRtkApi;
